import { Injectable, Optional } from '@angular/core';
import { AbstractApiController } from './abstract-api-controller';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../configuration';
import { DefaultResponseInterface } from '../model/response/default-response.interface';
import { RegistrationOwnersResponse } from '../model/response/registration-owners-response';
import { RegistrationOwnerEnumResponse } from '../model/response/registration-owner-enum-response';
import { RegistrationOwnerResponse } from '../model/response/registration-owner.response';
import { RegistrationOwnerRequest } from '../model/request/registration-owner-request';

@Injectable()
export class AdminRegistrationOwnerApi extends AbstractApiController {

  constructor(
    private http: HttpClient,
    @Optional() config?: Configuration
  ) {
    super();
    this.baseUrl = (config && config.apiBaseUrl)
      ? config.apiBaseUrl : 'https://example.com';
  }

  public fetchOwners(page, limit, filter) {
    return this.http.get<RegistrationOwnersResponse>(
      this.prepareListRequest(
        this.baseUrl + '/api/cf/administration/registration-owner',
        page,
        limit,
        [{name: 'ASC'}],
        filter
      ),
      {headers: this.getAuthHeaders()}
    );
  }

  public fetchOwnersEnum() {
    return this.http.get<RegistrationOwnerEnumResponse>(
      this.baseUrl + '/api/cf/administration/registration-owner/enum',
      {headers: this.getAuthHeaders()}
    );
  }

  public fetchDetail(id) {
    return this.http.get<RegistrationOwnerResponse>(
      this.baseUrl + '/api/cf/administration/registration-owner/' + id,
      {headers: this.getAuthHeaders()}
    );
  }

  public delete(id) {
    return this.http.delete<DefaultResponseInterface>(
      this.baseUrl + '/api/cf/administration/registration-owner/' + id,
      {headers: this.getAuthHeaders()}
    );
  }

  public saveNew(request: RegistrationOwnerRequest) {
    return this.http.post<DefaultResponseInterface>(
      this.baseUrl + '/api/cf/administration/registration-owner',
      request,
      {headers: this.getAuthHeaders()}
    );
  }
}
